import * as React from 'react';
import { classNames } from '@/utils';
import { ButtonIcon } from '../ButtonIcon';

/** This type defines the different levels of alerts that can be displayed */
export type AlertLevel = 'info' | 'success' | 'warning' | 'error';
export interface AlertProps {
  /** The content of the alert message */
  message: React.ReactNode;
  /**  The level of the alert ('info', 'success', 'warning', 'error') */
  level?: AlertLevel;
  /** Called when the alert is closed */
  onClose?(): void;
  /** Whether the alert can be closed (When false | undefined the close button will not be displayed) */
  closable?: boolean;
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props: AlertProps, ref) => {
  const { message, closable = false, level = 'info', onClose } = props;

  return (
    <article ref={ref} className={classNames('alert', { closable }, level)}>
      <p>{message}</p>
      <ButtonIcon className="close" onClick={onClose}>
        <i className="fa-regular fa-xmark" />
      </ButtonIcon>
    </article>
  );
});

Alert.displayName = 'Alert';
